import * as classes from "./mute-button.module.scss";
import MuteIcon from "../../icons/Mute.svg";
import UnmuteIcon from "../../icons/Unmute.svg";
import { useContext } from "react";
import {
  ActionType,
  AppContext,
  ControlsMode,
  ViewMode,
} from "../../contexts/AppContext";
import classNames from "classnames";

const MuteButton = () => {
  const { state, dispatch } = useContext(AppContext);
  const { isMuted, controlsMode, modal, viewMode } = state;

  return (
    <button
      className={classNames(classes.root, {
        [classes["root--centered"]]: controlsMode === ControlsMode.Joystick,
        [classes["root--is-hidden"]]: !!modal,
        [classes["root--is-green"]]: viewMode === ViewMode.Lookbook,
      })}
      onClick={() => {
        dispatch({ type: ActionType.ToggleMute });
      }}
      aria-label={isMuted ? "Unmute" : "Mute"}
    >
      {isMuted ? <UnmuteIcon /> : <MuteIcon />}
      {isMuted ? "Unmute" : "Mute"}
    </button>
  );
};

export default MuteButton;
